import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { renderComponent } from '../../helpers/component-renderer';
import { ENV } from '../../constants';

const DEFAULT_BANNER_URL = `${ENV.CDN_BASE_URL_IMAGES}/products-and-services.jpg`;

const ContentLayout = ({
  bannerSrc = null,
  title = '',
  components = [],
  styles = {},
}) => (
  <>
    <Box
      sx={{
        background: `url(${
          bannerSrc || DEFAULT_BANNER_URL
        }) lightgray 50% / cover no-repeat`,
        height: '25vw',
      }}
    />
    <Box sx={{ px: { xs: 2, md: 8 }, py: 4, ...styles.container }}>
      <Typography variant='h1' sx={{ mb: 1, ...styles.title }}>
        {title}
      </Typography>
      {components.map((component, index) => renderComponent(component, index))}
    </Box>
  </>
);

ContentLayout.propTypes = {
  title: PropTypes.string,
  bannerSrc: PropTypes.string,
  children: PropTypes.node,
  styles: PropTypes.object,
  components: PropTypes.array,
};

export default ContentLayout;
